import styled from 'styled-components'

export const StyledGroupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  .right {
    flex-shrink: 0;
  }
`
